import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiskGroup } from '../types';

interface RiskScoreResultProps {
  groups: RiskGroup[];
  activeLevel: string | null;
  score?: string | null;
  scoreLabel?: string;
  /** Shown under the rows while the inputs are still incomplete */
  emptyHint?: string;
}

const RiskScoreResult: React.FC<RiskScoreResultProps> = ({
  groups,
  activeLevel,
  score,
  scoreLabel,
  emptyHint,
}) => {
  const { t } = useTranslation('hematology');
  const hasResult = Boolean(activeLevel);

  return (
    <div className="risk-score-result">
      {score !== undefined && score !== null && (
        <div className="score-display">
          <span className="score-label">{scoreLabel || t('score')}</span>
          <span className="score-value">{score}</span>
        </div>
      )}

      <div className="risk-groups" role="list">
        {groups.map((group) => {
          const isActive = activeLevel === group.level;

          return (
            <div
              key={group.level}
              role="listitem"
              aria-current={isActive || undefined}
              className={[
                'risk-row',
                `risk-row--${group.tone}`,
                isActive ? 'is-active' : '',
                hasResult && !isActive ? 'is-muted' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <div className="risk-row__body">
                <div className="risk-row__label">
                  <span className="risk-row__label-he">{group.label}</span>
                </div>

                <div className="risk-row__criteria">
                  {group.criteria}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {!hasResult && emptyHint && (
        <p className="risk-empty-hint">{emptyHint}</p>
      )}
    </div>
  );
};

export default RiskScoreResult;
